import { Box, Container, Grid, GridItem, Icon, Text, VStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaCheckCircle } from 'react-icons/fa';

const MotionBox = motion(Box);

const StatCard = ({ number, label, delay }) => (
  <MotionBox
    initial={{ opacity: 0, scale: 0.8 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.5, delay }}
    viewport={{ once: true, amount: 0.3 }}
    textAlign="center"
  >
    <Text fontSize={{ base: '3xl', md: '4xl' }} fontWeight="900" color="white" mb={2}>
      {number}
    </Text>
    <Text fontSize={{ base: 'md', md: 'lg' }} color="gray.200">
      {label}
    </Text>
  </MotionBox>
);

const OutcomeItem = ({ title, description, delay }) => (
  <MotionBox
    initial={{ opacity: 0, x: -20 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.5, delay }}
    viewport={{ once: true, amount: 0.3 }}
    display="flex"
    alignItems="flex-start"
    gap={4}
  >
    <Icon as={FaCheckCircle} color="accent.gold" fontSize="20px" mt={1} flexShrink={0} />
    <VStack align="start" spacing={1}>
      <Text fontSize={{ base: 'md', md: 'lg' }} fontWeight="700" color="white">
        {title}
      </Text>
      <Text fontSize="sm" color="gray.300">
        {description}
      </Text>
    </VStack>
  </MotionBox>
);

const GetHiredOutcomes = ({ data }) => {
  return (
    <Box
      bg={`linear-gradient(135deg, #1A1F2E 0%, #1F2B3D 100%)`}
      py={{ base: 12, md: 16 }}
    >
      <Container maxW="6xl">
        <VStack spacing={16}>
          {/* Stats Section */}
          <VStack spacing={8} w="full">
            <Text
              as="h2"
              fontSize={{ base: '2xl', md: '3xl' }}
              fontWeight="900"
              color="white"
              textAlign="center"
            >
              {data.title}
            </Text>

            <Grid
              templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }}
              gap={{ base: 8, md: 12 }}
              w="full"
            >
              {data.stats.map((stat, idx) => (
                <GridItem key={idx}>
                  <StatCard
                    number={stat.number}
                    label={stat.label}
                    delay={idx * 0.1}
                  />
                </GridItem>
              ))}
            </Grid>
          </VStack>

          {/* Outcomes Grid */}
          <Grid
            templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
            gap={{ base: 6, md: 10 }}
            w="full"
          >
            {data.outcomes.map((outcome, idx) => (
              <GridItem key={idx}>
                <OutcomeItem
                  title={outcome.title}
                  description={outcome.description}
                  delay={0.3 + idx * 0.1}
                />
              </GridItem>
            ))}
          </Grid>
        </VStack>
      </Container>
    </Box>
  );
};

export default GetHiredOutcomes;
